import { useRouter } from "expo-router";
import { useEffect, useRef } from "react";

import { useAuthApi } from "@/services/authApi";
import {
  isSessionExpired,
  subscribeSessionExpired,
} from "@/services/sessionExpiryEvents";

export const useSessionExpiryGuard = () => {
  const router = useRouter();
  const { logout } = useAuthApi();
  const handledRef = useRef(false);

  useEffect(() => {
    const logoutAndRedirectToLogin = async () => {
      if (handledRef.current) {
        return;
      }

      handledRef.current = true;
      try {
        await logout();
      } catch (error) {
        console.error("Failed to logout after session expiry:", error);
      }
      router.replace({
        pathname: "/",
        params: { sessionExpired: "1" },
      });
    };

    if (isSessionExpired()) {
      void logoutAndRedirectToLogin();
    }

    const unsubscribe = subscribeSessionExpired(() => {
      void logoutAndRedirectToLogin();
    });

    return () => {
      unsubscribe();
    };
  }, [logout, router]);
};
